import lang from '../assets/lang/v1';

class langRegister {

    static file = lang;
    static language = "sv";

    static getItem(view, item, lang){
        try {
            let language = "";
            if(!lang){
                language = langRegister.language;
                try{
                    if(sessionStorage.getItem("language")){
                        language = sessionStorage.getItem("language");
                    }
                }catch (e) {}
            }else{
                language = lang;
            }
            if(langRegister.file[view][item][language]){
                return langRegister.file[view][item][language];
            }else{
                return "-";
            }
        }catch (error) {
            return "-";
        }
    }

    static setLanguage(lang, init){
        langRegister.language = lang;
        try {
            sessionStorage.setItem("language", lang);
        }catch (e) {}
        if(!init){
            try {
                langRegister.setAPILanguage(lang, ['places'], 'AIzaSyAOpL-2YHBEYSGq6cvFshbk9AidtmdrznU').then(() => {
                    //The API is loaded here
                });
            }catch (e) {}
        }
    }

    static getLanguage(){
        try{
            if(sessionStorage.getItem("language")){
                return  sessionStorage.getItem("language");
            }else{
                return langRegister.language;
            }
        }catch (e) {
            return langRegister.language;
        }
    }

    static setAPILanguage = (lang, libraries, key) => {
        //Destroy old API

        console.log("hej");

        document.querySelectorAll('script[src^="https://maps.googleapis.com"]').forEach(script => {
            script.remove();
        });

        //Generate new Google Maps API script
        let newAPI = document.createElement('script');
        newAPI.src = 'https://maps.googleapis.com/maps/api/js?libraries=' + libraries.join(',') + '&key=' + key + '&language=' + lang + '&callback=googleMapsAPILoaded';

        //Callback for the Google Maps API src
        window.googleMapsAPILoaded = () => {
            let event = new CustomEvent('googleMapsAPILoaded');
            window.dispatchEvent(event);
        };

        //Wait for the callback to be executed
        let apiLoaded = new Promise(resolve => {
            window.addEventListener('googleMapsAPILoaded', () => {
                resolve();
            });
        });

        //Start the script
        document.querySelector('head').appendChild(newAPI);

        return apiLoaded;
    };

    //SHORTENER
    static get(view, item, lang){
        return langRegister.getItem(view, item, lang);
    }

    static set(lang, init){
        langRegister.setLanguage(lang, init);
    }

    static lang(){
        return langRegister.getLanguage();
    }

}

export {langRegister}


// WEBPACK FOOTER //
// ./src/services/langRegister.js